import { render, staticRenderFns } from "./Holidays.vue?vue&type=template&id=9d34db28&scoped=true&"
import script from "./Holidays.vue?vue&type=script&lang=ts&"
export * from "./Holidays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d34db28",
  null
  
)

export default component.exports